module.exports = __webpack_public_path__ + "img/section1_bg.3c59987c.png";